import styled from 'styled-components';

export const CollapseContainer = styled.div<{ $duration?: number }>`
  .ReactCollapse--collapse {
    transition: height ${({ theme, $duration }) => $duration ?? theme.motion.duration.short}ms ease-in-out;
  }
`;
